module.exports = __webpack_public_path__ + "static/media/Paid.dca25cb3.svg";